export default __webpack_public_path__ + "static/media/SLD1-B.865590e4.png";